export default "__VITE_ASSET__BmXv2dad__"